import {DEFAULT_STATS_TABLE_VERTICAL_DIVIDER_COLOR} from "../../../../utils/colors";

const dividerStyle = {
  width: 1,
  height: 84,
  backgroundColor: DEFAULT_STATS_TABLE_VERTICAL_DIVIDER_COLOR,
  margin: '0 10px',
}

const MyStatsTableVerticalDivider = () => <div style={dividerStyle}></div>;

export default MyStatsTableVerticalDivider;